import { render } from "./DiseaseList.vue?vue&type=template&id=0dabb496"
import script from "./DiseaseList.vue?vue&type=script&lang=js"
export * from "./DiseaseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__